var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.0003C7.04167 15.0003 6.64931 14.8371 6.32292 14.5107C5.99653 14.1844 5.83333 13.792 5.83333 13.3337V3.33366C5.83333 2.87533 5.99653 2.48296 6.32292 2.15658C6.64931 1.83019 7.04167 1.66699 7.5 1.66699H15C15.4583 1.66699 15.8507 1.83019 16.1771 2.15658C16.5035 2.48296 16.6667 2.87533 16.6667 3.33366V13.3337C16.6667 13.792 16.5035 14.1844 16.1771 14.5107C15.8507 14.8371 15.4583 15.0003 15 15.0003H7.5ZM7.5 13.3337H15V3.33366H7.5V13.3337ZM4.16667 18.3337C3.70833 18.3337 3.31597 18.1705 2.98958 17.8441C2.66319 17.5177 2.5 17.1253 2.5 16.667V5.83366C2.5 5.59755 2.57986 5.39963 2.73958 5.23991C2.89931 5.08019 3.09722 5.00033 3.33333 5.00033C3.56944 5.00033 3.76736 5.08019 3.92708 5.23991C4.08681 5.39963 4.16667 5.59755 4.16667 5.83366V16.667H12.5C12.7361 16.667 12.934 16.7469 13.0937 16.9066C13.2535 17.0663 13.3333 17.2642 13.3333 17.5003C13.3333 17.7364 13.2535 17.9344 13.0937 18.0941C12.934 18.2538 12.7361 18.3337 12.5 18.3337H4.16667Z",
    fill: "#4CAF50",
    stroke: "#4CAF50",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGreenIcon);
export default __webpack_public_path__ + "static/media/copy-green-icon.7650bf7a4de4d997ac4ab2c8a5c85bac.svg";
export { ForwardRef as ReactComponent };